import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "@/context/CartContext";
import { useSettings } from "@/context/SettingsContext";
import { Button } from "@/components/ui/button";

const links = [
  { name: "Our Pickles", to: "/shop", testid: "nav-link-shop" },
  { name: "Family Pack", to: "/bulk-box", testid: "nav-link-bulkbox" },
  { name: "Gift Box", to: "/gift-box", testid: "nav-link-giftbox" },
  { name: "My Orders", to: "/my-orders", testid: "nav-link-myorders" },
  { name: "Our Story", to: "/about", testid: "nav-link-about" },
];

export default function Navbar() {
  const { count, openCart } = useCart();
  const { announcement_lines } = useSettings();
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const ticker = (announcement_lines || []).length ? announcement_lines : ["Homemade with love"];
  const ticker2x = [...ticker, ...ticker];

  return (
    <>
      {/* Announcement ticker */}
      <div className="bg-[#1E1B18] text-[#FBF8F3] text-xs sm:text-sm py-2 ticker-wrap">
        <div className="ticker" data-testid="announcement-ticker">
          {ticker2x.map((line, i) => (
            <span key={i} className="mx-8">✦ {line}</span>
          ))}
        </div>
      </div>

      <header className="sticky top-0 z-40 backdrop-blur-md bg-[#FBF8F3]/90 border-b border-[#E6DEC3]/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 sm:h-20">
            <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
              <img
                src="/logo.jpeg"
                alt="Dadu's Achaar"
                className="w-11 h-11 sm:w-12 sm:h-12 rounded-full object-cover shadow-sm ring-2 ring-[#E5A83B]/60 group-hover:ring-[#9E3B21] transition-all"
              />
              <div className="flex flex-col leading-tight">
                <span className="font-serif text-lg sm:text-xl font-semibold tracking-tight">Dadu&apos;s Achaar</span>
                <span className="text-[10px] uppercase tracking-[0.25em] text-[#6E675F]">Ghar ka Swaad · Dadu ka Vaada</span>
              </div>
            </Link>

            <nav className="hidden md:flex items-center gap-6 lg:gap-7">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  data-testid={l.testid}
                  className={({ isActive }) =>
                    `text-sm font-medium tracking-wide transition-colors ${
                      isActive ? "text-[#9E3B21]" : "text-[#1E1B18] hover:text-[#9E3B21]"
                    }`
                  }
                >
                  {l.name}
                </NavLink>
              ))}
            </nav>

            <div className="flex items-center gap-2">
              <button
                data-testid="cart-open-btn"
                onClick={openCart}
                className="relative rounded-full p-2.5 hover:bg-[#F4EFE6] transition-colors"
                aria-label="Open cart"
              >
                <ShoppingBag className="w-5 h-5 text-[#1E1B18]" />
                {count > 0 && (
                  <span
                    data-testid="cart-badge-count"
                    className="absolute -top-1 -right-1 bg-[#9E3B21] text-[#FBF8F3] text-[10px] font-semibold rounded-full w-5 h-5 flex items-center justify-center"
                  >
                    {count}
                  </span>
                )}
              </button>

              <Button
                data-testid="nav-cta-shop"
                onClick={() => navigate("/shop")}
                className="hidden sm:inline-flex btn-primary rounded-full px-5 py-2 text-sm font-medium"
              >
                Shop Now
              </Button>

              <button
                className="md:hidden p-2 rounded-full hover:bg-[#F4EFE6]"
                onClick={() => setMobileOpen((s) => !s)}
                data-testid="nav-mobile-toggle"
                aria-label="Menu"
              >
                {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
              </button>
            </div>
          </div>

          {mobileOpen && (
            <div className="md:hidden py-4 border-t border-[#E6DEC3]/60">
              <div className="flex flex-col gap-3">
                {links.map((l) => (
                  <Link
                    key={l.to}
                    to={l.to}
                    data-testid={`${l.testid}-mobile`}
                    className="text-sm font-medium py-2"
                    onClick={() => setMobileOpen(false)}
                  >
                    {l.name}
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </header>
    </>
  );
}
